import React from "react";
import { useRoutes } from "react-router-dom";
import { routes } from "./routes";
import classes from "./Page.module.scss"
import {  getAdminToken } from "../utils/helpers";
import MainContextProvider from "../context/context";
const Pages = () => {
  const adminToken = getAdminToken();
  
  return (
    <div className={classes.page}>
     <React.Suspense fallback={<p>Loading..</p>}>
     <MainContextProvider> {useRoutes(routes(adminToken))}</MainContextProvider>
    </React.Suspense>
    </div>
 
  );
};

export default Pages;
